export default {
  buttons: {
    remove: 'Usuń',
  },
  title: 'Kod promocyjny lub karta podarunkowa',
};
